import { render } from "./Navbar.vue?vue&type=template&id=4ebb966b&scoped=true"
const script = {}

import "./Navbar.vue?vue&type=style&index=0&id=4ebb966b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebb966b"]])

export default __exports__